module.exports = "/packs/benefits-of-attending-mokumoku-image-85f5d80b0f0942360eec2fd4cc4022d4.png";